import { ArrowUpDown } from 'lucide-react'

import { FilterOptionList, type FilterOption } from '@/components/filters/filter-menu'
import { FilterPopoverPanel } from '@/components/filters/filter-dropdown-shell'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export type ListSortMenuProps = {
  options: FilterOption[]
  value: string
  onValueChange: (value: string) => void
  ariaLabel?: string
  contentClassName?: string
  disabled?: boolean
}

export function ListSortMenu({
  options,
  value,
  onValueChange,
  ariaLabel = 'Sort',
  contentClassName = 'w-52',
  disabled = false,
}: ListSortMenuProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          type="button"
          variant="ghostMuted"
          size="iconSm"
          className="shrink-0"
          disabled={disabled}
          aria-label={ariaLabel}
          title={ariaLabel}
        >
          <ArrowUpDown className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className={contentClassName}>
        <FilterPopoverPanel>
          <FilterOptionList type="single" options={options} value={value} onValueChange={onValueChange} />
        </FilterPopoverPanel>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
